import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { getThousandComma } from "../../../../Api/ApiCommon";
import { useApi } from "../../../../hooks/useApi";
import LineBox from "../../../DefaultStyles/LineBox";
import {
  DashBoardSectionTitle,
  DashBoardSectionTitleContainer,
  DashBoardViewDate,
  IndateSectionProps,
} from "./IndateSection";
import Chart from "react-apexcharts";
import DashBoardToggleBtn from "../DashBoardToggleBtn";

interface GenderSectionProps extends IndateSectionProps {}

export default function GenderSection({
  filter,
  setFilter,
}: GenderSectionProps) {
  const date = dayjs().format("YYYY-MM-DD");

  const { response } = useApi({
    method: "get",
    url:
      filter.startDate !== "" && filter.endDate !== ""
        ? `dash/total?type=user&subtype=gender&startdate=${
            filter?.isAccum
              ? date
              : dayjs(filter.startDate).add(1, "day")?.format("YYYY-MM-DD")
          }&enddate=${
            filter?.isAccum
              ? date
              : dayjs(filter.endDate).add(1, "day")?.format("YYYY-MM-DD")
          }&filter=day`
        : undefined,
  });

  const [series, setSeries] = useState<number[]>([]);

  useEffect(() => {
    if (response?.status === 200) {
      const total = response.data.reduce((acc: any, cur: any) => {
        acc[0] = (acc[0] || 0) + (cur.detail === "female" ? cur.data.count : 0);
        acc[1] = (acc[1] || 0) + (cur.detail === "male" ? cur.data.count : 0);

        return acc;
      }, []);

      setSeries(total);
    }
  }, [response, filter]);

  return (
    <>
      <DashBoardSectionTitleContainer>
        <DashBoardSectionTitle>가입자 성별</DashBoardSectionTitle>

        <DashBoardToggleBtn
          btnTextArray={["기간", "누적"]}
          filter={filter}
          setFilter={setFilter}
        />
      </DashBoardSectionTitleContainer>

      <LineBox boxPadding={"28px 32px"}>
        <DashBoardViewDate>
          {filter?.isAccum
            ? `${filter.endDate} 기준`
            : `조회 기간: ${filter.startDate} ~ ${filter.endDate}`}
        </DashBoardViewDate>

        <>
          <div style={{ width: "100%", height: 330 }}>
            <Chart
              type="pie"
              height={350}
              series={series}
              options={{
                chart: {
                  type: "pie",
                },
                labels: ["여성", "남성"],
                legend: {
                  position: "bottom",
                  fontFamily:
                    "-apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', Pretendard Variable, Roboto, 'Noto Sans KR', 'Segoe UI', 'Malgun Gothic', sans-serif",
                  markers: {
                    width: 10,
                    height: 10,
                    offsetX: -4,
                    radius: 10,
                  },
                  fontSize: "13px",
                  fontWeight: 500,
                  itemMargin: {
                    horizontal: 10,
                  },
                },
                plotOptions: {
                  pie: {
                    dataLabels: {
                      offset: -40,
                    },
                  },
                },
                dataLabels: {
                  formatter: (val, { w, seriesIndex }) => {
                    return `${Math.round(Number(val) * 10) / 10}%`;
                  },
                  dropShadow: {
                    blur: 2,
                  },
                  style: {
                    fontWeight: 500,
                  },
                },
                tooltip: {
                  y: {
                    formatter: (val) => `${getThousandComma(val)}명`,
                  },
                },
              }}
            />
          </div>
        </>
      </LineBox>
    </>
  );
}
